import EnumClass, { build } from '../EnumClass';
import { filter } from 'fp-ts/lib/Array';
import data, { AbilityId, AbilityData } from './data';
import * as Translations from './translations';
import { pipe } from 'fp-ts/lib/pipeable';

export enum Subject {
  User = 'User',
  Teacher = 'Teacher',
  StaffMember = 'StaffMember',
}

const isSubject = (x: unknown): x is Subject => {
  return x === Subject.User || x === Subject.Teacher || x === Subject.StaffMember;
};

export class Ability extends EnumClass<AbilityId, AbilityData> {
  public get getName() {
    return Translations.name[this.id];
  }

  public get getDescription() {
    return Translations.description[this.id];
  }

  public get privileged() {
    return this.metadata.privileged;
  }

  public get universal() {
    return this.metadata.universal;
  }

  public get managedBy() {
    return getAbilityById(this.metadata.managed_by);
  }

  public get subjects(): Subject[] {
    return pipe(
      this.metadata.subjects,
      filter(isSubject),
    );
  }
}

export const {
  list: ABILITIES,
  getById: getAbilityById,
  marshaller: AbilityMarshaller,
  isId: isAbilityId,
} = build<AbilityId, AbilityData, Ability>('AbilityEnum', data, Ability);

export default Ability;
